import React from 'react';
import LogoImage from './icons/tegLogo.jpg';

const Logo = ({className})=> {
    return (
        <img src={LogoImage} className={className} />
    )
}

export default Logo;